// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 682) return "static/css/682.1f94a0116067c7784c23.lib.css";
	if (chunkId === 368) return "static/css/368.07b2bc1a2144c75e93cc.css";
	// return url for filenames based on template
	return undefined;
};